export class HasErrorIgnore {

    constructor() {}
    /*
     * Исключаем не понятные/не решаемые ошибки
     */
    public execute(message: string): boolean {
        var errorsToIgnore = [
            // Плагины и приложения
            'top.GLOBALS',
            'originalCreateNotification', // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
            'canvas.contentDocument',
            'MyApp_RemoveAllHighlights',
            'Can\'t find variable: ZiteReader',
            'jigsaw is not defined',
            'ComboSearch is not defined',
            'http://loading.retry.widdit.com/',
            'atomicFindClose',
            'topMsg is not defined',
            'SyntaxError: Unexpected identifier',
            'SyntaxError: Unexpected token &#39;else&#39;',
            'SyntaxError: Unexpected end of input',
            'TypeError: Cannot read property &#39;0&#39; of undefined',
            'Can&#39;t find variable: __gCrWeb',
            '@[native code] ',
            'redefine non-configurable property', // TypeError: can&#39;t redefine non-configurable property &#34;userAgent&#34;
            // Probably comes from extensions: http://stackoverflow.com/questions/5913978/cryptic-script-error-reported-in-javascript-in-chrome-and-firefox
            'Script error.',
            'ReferenceError: processRandomSelector is not defined',
            'clickcnt.js'
        ];

        for (let i = 0; i < errorsToIgnore.length; i++) {
            if (message.indexOf(errorsToIgnore[i]) > -1) {
                return true;
            }
        }

        if (message.indexOf('The string did not match the expected pattern') > -1 && message.indexOf('@[native code]') > -1) {
            return true;
        }

        return false;
    }
}
